import WrapPage from "../components/wrapPage"
import ContactPage from "../contactPage"

export default WrapPage(ContactPage)
